import * as React from "react";
const SvgRectangleOutlined = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} {...props}>
    <path fill="none" d="M0 0h24v24H0z" />
    <path d="M2 4v16h20V4H2zm18 14H4V6h16v12z" />
  </svg>
);
export default SvgRectangleOutlined;
